import {
  Component,
  Output,
  EventEmitter,
  ViewEncapsulation,
  signal,
} from '@angular/core';
import { AppSettings } from 'src/app/config';
import { CoreService } from 'src/app/shared/services/core.service';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule } from '@angular/forms';
import { NgScrollbarModule } from 'ngx-scrollbar';

@Component({
  selector: 'app-customizer',
  imports: [
    TablerIconsModule,
    MaterialModule,
    FormsModule,
    NgScrollbarModule,
  ],
  templateUrl: './customizer.component.html',
  styleUrls: ['./customizer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CustomizerComponent {

  get options() {
    return this.settings.getOptions();
  }


  @Output() optionsChange = new EventEmitter<AppSettings>();
  hideSingleSelectionIndicator = signal(true);

  constructor(private settings: CoreService) { }

  setDark(theme: string) {
    this.settings.setOptions({ theme });
    this.emitOptions();
  }

  setColor(color: string) {
    this.settings.setOptions({ activeTheme: color });
    this.emitOptions();
  }

  setDir(dir: 'ltr' | 'rtl') {
    this.settings.setOptions({ dir: dir });
    this.emitOptions();
  }

  setSidebar(sidenavCollapsed: boolean) {
    this.settings.setOptions({ sidenavCollapsed });
    this.emitOptions();
  }

  private emitOptions() {
    this.optionsChange.emit(this.options);
  }

  setHorizontal(horizontal: boolean) {
    this.settings.setOptions({
      horizontal,
      navPos: horizontal ? 'top' : 'side',
      ...(horizontal
        ? { sidenavCollapsed: false }
        : { sidenavOpened: true }),  // ← bring sidebar back
    });
    this.emitOptions();
  }

  setCardBorder(cardBorder: boolean) {
    this.settings.setOptions({ cardBorder });
    this.emitOptions();
  }

  setBoxed(boxed: boolean) {
    this.settings.setOptions({ boxed });
    this.emitOptions();
  }
}

